// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as NextImage$PorterinFeature from "./NextImage.mjs";
import * as PublishEventsHelper$PorterinFeature from "../../shared/core/helpers/PublishEventsHelper.mjs";
import * as FormInputModuleScss from "@porterin/feature/src/ui/styles/common/FormInput.module.scss";

function SubmitBtnCmp(Props) {
  var is_disabled = Props.is_disabled;
  var className = Props.className;
  var icon_label = Props.icon_label;
  var category = Props.category;
  var is_loadingOpt = Props.is_loading;
  var call_backOpt = Props.call_back;
  var event_name = Props.event_name;
  var is_loading = is_loadingOpt !== undefined ? is_loadingOpt : false;
  var call_back = call_backOpt !== undefined ? call_backOpt : (function (param) {
        
      });
  var ctaClassName = "" + FormInputModuleScss.submit + " " + (
    is_disabled && !is_loading ? FormInputModuleScss["submit-disabled"] : FormInputModuleScss["submit-enabled"]
  ) + " " + className + "";
  return React.createElement("button", {
              className: ctaClassName,
              disabled: is_disabled,
              onClick: (function (param) {
                  Curry._1(call_back, undefined);
                  if (event_name !== undefined) {
                    return PublishEventsHelper$PorterinFeature.publishEvents(category, event_name, undefined);
                  }
                  
                })
            }, is_loading ? React.createElement("div", {
                    className: FormInputModuleScss.loading
                  }) : React.createElement(React.Fragment, undefined, React.createElement("div", {
                        className: FormInputModuleScss["submit-text"]
                      }, icon_label.label), React.createElement("div", {
                        className: FormInputModuleScss["submit-arrow-icon"]
                      }, React.createElement(NextImage$PorterinFeature.make, {
                            src: icon_label.icon.path,
                            height: 16.0,
                            width: 16.0,
                            quality: 100.0,
                            alt: icon_label.icon.alt_text
                          }))));
}

var make = SubmitBtnCmp;

export {
  make ,
}
/* react Not a pure module */
